var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAddress38Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Haldus",
    transform: "translate(-16.000000, -219.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3",
    transform: "translate(16.000000, 219.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5638852,-1.03584031e-16 L35.4361148,1.03584031e-16 C36.3276335,-6.01853049e-17 36.6509198,0.0928256111 36.9768457,0.267132704 C37.3027716,0.441439796 37.5585602,0.697228371 37.7328673,1.0231543 C37.9071744,1.34908022 38,1.67236646 38,2.5638852 L38,35.4361148 C38,36.3276335 37.9071744,36.6509198 37.7328673,36.9768457 C37.5585602,37.3027716 37.3027716,37.5585602 36.9768457,37.7328673 C36.6509198,37.9071744 36.3276335,38 35.4361148,38 L2.5638852,38 C1.67236646,38 1.34908022,37.9071744 1.0231543,37.7328673 C0.697228371,37.5585602 0.441439796,37.3027716 0.267132704,36.9768457 C0.0928256111,36.6509198 4.01235366e-17,36.3276335 -6.90560205e-17,35.4361148 L6.90560205e-17,2.5638852 C-4.01235366e-17,1.67236646 0.0928256111,1.34908022 0.267132704,1.0231543 C0.441439796,0.697228371 0.697228371,0.441439796 1.0231543,0.267132704 C1.34908022,0.0928256111 1.67236646,6.01853049e-17 2.5638852,-1.03584031e-16 Z",
    id: "Rectangle",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.000000, 11.000000)",
    stroke: "#FFCD00",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9645355,11.3030779 L7.00228577,16 L2.04003601,11.3030779 C-0.680012004,8.72846875 -0.680012004,4.55342688 2.04003601,1.97881808 L2.07679342,1.94402606 C4.79684144,-0.630583435 9.17097271,-0.66537545 11.9277781,1.94402572 C14.6845836,4.55342688 14.6845836,8.72846875 11.9645355,11.3030779 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,7 C9,8.104568 8.104568,9 7,9 C5.895432,9 5,8.104568 5,7 C5,5.895432 5.895432,5 7,5 C8.104568,5 9,5.895432 9,7 Z",
    id: "Stroke-3"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddress38Px);
export default __webpack_public_path__ + "static/media/Icon_Address-38px.a7ffd1d9d7d4b0978f3a54efeff87f45.svg";
export { ForwardRef as ReactComponent };